<template>
  <div class="header-bottom"></div>
</template>
<script>
import { mapActions } from 'vuex'

import Cart from './cart/Cart'
import LoginForm from './login-form'
import Popap from './popap'
import VlButton from '@components/@exim/ui/vl-button'
import VlIconBase from '@components/@exim/ui/vl-icons'
import VlIconBasket from '@components/@exim/ui/vl-icons/VlIconBasket'
import VlIconAvatar from '@components/@exim/ui/vl-icons/VlIconAvatar'
import locales from './locales'
import {
  CATALOG,
  ORDER_SHOW,
  AUTHORIZATION_LOGIN,
  AUTHORIZATION_LOGOUT,
} from '@javascript/config/routes'

export default {
  name: 'HeaderBottom',
  components: {
    Cart,
    LoginForm,
    Popap,
    VlButton,
    VlIconBase,
    VlIconBasket,
    VlIconAvatar,
  },
  props: {
    isLogin: {
      type: Boolean,
      default: false,
    },
    userData: {
      type: Object,
      default: null,
    },
    userName: {
      type: String,
      default: false,
    },
    profileMenu: {
      type: Array,
      default: null,
    },
    locale: {
      type: String,
      default: '',
    },
    defaultLocale: {
      type: String,
      default: '',
    },
    baseUrlWithLocale: {
      type: String,
      default: '',
    },
    providerId: {
      type: [String, Number],
      default: null,
    },
  },
  data: () => ({
    t: locales,
    isShowLoginBar: false,
    isShowMobileMenu: false,
    isShowLoginForm: false,
  }),
  computed: {
    catalogRouter() {
      return `${this.baseUrlWithLocale}${CATALOG}`
    },
    isOrderPage() {
      const orderRouter = `${this.baseUrlWithLocale}${ORDER_SHOW}`
      return window.location.pathname == orderRouter
    },
    balance() {
      return this.userData
        ? `${this.userData.balance} ${this.userData.site_currency}`
        : ''
    },
    isLoginPage() {
      const loginRouter = `${this.baseUrlWithLocale}${AUTHORIZATION_LOGIN}`
      return window.location.pathname === loginRouter
    },
    authorizationLoginRouter() {
      return `${this.baseUrlWithLocale}${AUTHORIZATION_LOGOUT}`
    },
  },
  methods: {
    ...mapActions({
      API_LOGOUT: 'authorization/API_LOGOUT',
    }),
    toggleLoginBar() {
      this.isShowLoginBar = !this.isShowLoginBar
    },
    toggleMobileMenu() {
      this.$emit('click', !this.isShowMobileMenu)
    },
    toggleLoginForm() {
      this.isShowLoginForm = !this.isShowLoginForm
    },
    closeModal(modalName) {
      this[modalName] = false
    },
  },
}
</script>
